import { FC, useState } from "react";
import styles from "./About.module.scss";
import { Modal } from "../../components/common/Modal";
import { RulesOfPay } from "../../components/ui/RulesOfPay";
import { RulesCorp } from "../../constants/hints";
import { phoneFormatter } from "../../utils/telephoneMask";

import LicenzeImage from "../../icons/licenze.jpg";
import LicenzeImage2 from "../../icons/licenze2.jpg";
import LicenzeImage3 from "../../icons/licenze3.jpg";
import LicenzeImageWebp from "../../icons/licenze.webp";
import LicenzeImage2Webp from "../../icons/licenze2.webp";
import LicenzeImage3Webp from "../../icons/licenze3.webp";
import { ModalImages } from "../../components/ui/ModalImages";
import OfficeImage from "../../icons/office.jpg";

const images = [
  { img: LicenzeImage, webp: LicenzeImageWebp },
  { img: LicenzeImage2, webp: LicenzeImage2Webp },
  { img: LicenzeImage3, webp: LicenzeImage3Webp },
];

interface AboutProps {
  classess?: string;
}

const About: FC<AboutProps> = ({ classess }) => {
  const [modal, setModal] = useState(false);
  const [modalImages, setModalImages] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const openImagesModal = (index: number) => {
    setModalImages(true);
    setActiveIndex(index);
  };
  return (
    <div className={styles.About}>
      <div className={styles.topFlex}>
        <div className={styles.topFlex__left}>
          <p>
            <strong>Кокоткина Елена Александровна</strong> - Директор «ООО
            Денталика», врач стоматолог-ортопед высшей категории
          </p>

          <span onClick={() => setModal(true)}>
            Правила положения о платных медицинских услугах
          </span>
        </div>
        <img src={OfficeImage} alt="place_photo" />
      </div>

      <div className={styles.rulesCorp}>
        <strong>Высшестоящие организации:</strong>
        <ul>
          {RulesCorp.map(({ tel, text }) => (
            <li key={tel}>
              {text}{" "}
              <a href={"tel:" + tel}>
                <strong>{phoneFormatter(tel)}</strong>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <ul className={styles.licenze}>
        {images.map(({ img, webp }, i) => (
          <li key={i.toString()} onClick={() => openImagesModal(i)}>
            <picture>
              <source srcSet={webp} type="image/webp" />
              <img
                style={i === 1 ? { transform: "rotate(-1deg)" } : {}}
                src={img}
                alt="licenze"
              />
            </picture>
          </li>
        ))}
      </ul>
      <Modal
        isOpen={modal}
        onClose={() => setModal(false)}
        children={<RulesOfPay />}
      />
      <ModalImages
        images={images}
        activeIndex={activeIndex}
        isOpen={modalImages}
        setIndex={setActiveIndex}
        onClose={() => setModalImages(false)}
      />
    </div>
  );
};

export default About;
